import { HttpClient } from '@store/base';
import _ from 'lodash';
import querystring from 'query-string';
import { GetGoodsQnAListRequest, GetGoodsQnAListResponse } from '../../model';

export class GetGoodsQnAListGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetGoodsQnAListRequest) {
    const query = querystring.stringify(_.omit(req, 'gdsNo'));

    return await this.httpClient.request<GetGoodsQnAListResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/goods-service/api/v1/goods/${req.gdsNo}/qna?${query}`,
    });
  }
}

export class WriteGoodsQnAGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetGoodsQnAListRequest) {
    return await this.httpClient.request<GetGoodsQnAListResponse>({
      method: 'POST',
      url: `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/goods-service/api/v1/goods/${req.gdsNo}/qna`,
      body: _.omit(req, 'gdsNo'),
    });
  }
}
